// import { withdrawalConstants } from "actions/types";
import type { WithdrawalsState } from "types/state";

const initialState: WithdrawalsState = {};

export function withdrawals(
  state: WithdrawalsState = initialState,
  action: { type: string }
): WithdrawalsState {
  switch (action.type) {
    default:
      return state;
  }
}
